/**
 * Service Category master-specific translation keys
 */
export const serviceCategory = {
  list: {
    search_placeholder: "admin.service_category_search_placeholder",
    main_heading: "admin.service_category_list_heading",
    create_btn_text: "admin.service_category_create_btn_text",
    table: {
      name_col_heading: "admin.service_category_name_table_col_heading",
      name_de_col_heading: "admin.service_category_name_de_table_col_heading",
      status_col_heading: "admin.service_category_status_table_col_heading",
      created_at_col_heading: "admin.service_category_created_at_table_col_heading",
      updated_at_col_heading: "admin.service_category_updated_at_table_col_heading",
      action_col_heading: "admin.service_category_action_table_col_heading",
    },
    status: {
      active: "admin.service_category_status_active",
      inactive: "admin.service_category_status_inactive",
    },
    status_filter_options: {
      all: "admin.service_category_status_filter_all",
      active: "admin.service_category_status_filter_active",
      inactive: "admin.service_category_status_filter_inactive",
    },
    delete_popup_heading_text: "admin.service_category_delete_popup_heading_text",
    delete_popup_message_text: "admin.service_category_delete_popup_message_text",
    delete_popup_yes_btn_text: "admin.service_category_delete_popup_yes_btn_text",
    delete_popup_no_btn_text: "admin.service_category_delete_popup_no_btn_text",
    status_popup_heading_text: "admin.service_category_status_popup_heading_text",
    status_popup_yes_btn_text: "admin.service_category_status_popup_yes_btn_text",
    status_popup_no_btn_text: "admin.service_category_status_popup_no_btn_text",
    clear_filter_btn_text: "admin.service_category_clear_filter_btn_text",
  },
  add: {
    main_heading: "admin.service_category_add_heading",
  },
  edit: {
    main_heading: "admin.service_category_edit_heading",
  },
  form: {
    name_label: "admin.service_category_name_label",
    name_placeholder: "admin.service_category_name_placeholder",
    name_de_label: "admin.service_category_name_de_label",
    name_de_placeholder: "admin.service_category_name_de_placeholder",
    status_label: "admin.service_category_status_label",
    submit_btn_text: "admin.service_category_submit_btn_text",
    update_btn_text: "admin.service_category_update_btn_text",
    cancel_btn_text: "admin.service_category_cancel_btn_text",
    loading_btn_text: "admin.service_category_loading_btn_text",
  },
};
